<template>
  <Component
    :is="disabled ? 'div' : ComboboxItem"
    class="flex items-center gap-2 row"
    :class="cn(variants({ size, hideSelected }), props.class)"
  >
    <Dot v-if="type === 'dot' && item.dot" :variant="item.dot" />
    <Avatar
      v-if="type === 'avatar'"
      :src="item.avatar_url"
      :initials="item.avatar_initials"
      size="xs"
      shape="square"
    />
    <Icon v-if="type === 'icon' && item.icon" :name="item.icon" />
    <span class="text-primary">
      {{ label }}
    </span>
    <span v-if="type === 'avatar' && item.user_tag" class="text-tertiary">
      @{{ item.user_tag }}
    </span>
    <slot name="indicator" />
  </Component>
</template>

<script setup>
import { cn } from "@/Utils/cn";
import { Avatar } from "@/SharedComponents/Avatars";
import { ComboboxItem } from "radix-vue";
import { Dot } from "@/SharedComponents/Dots";
import { Icon } from "@/SharedComponents/Icon";
import { variants } from ".";
import { computed } from "vue";

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  type: {
    type: String,
    default: "default",
  },
  class: {
    type: null,
    required: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
  },
  hideSelected: {
    type: Boolean,
    default: false,
  },
  labelKey: {
    type: String,
    default: "label",
  },
});

const label = computed(() => {
  return props.item[props.labelKey];
});
</script>
